import { useMutation } from '@tanstack/react-query';
import { apiDeleteAllocations } from '../../../../api';

interface DeleteAllocationParams {
  projectId: string;
  financialDocumentId: string;
  allocationIds: string[];
}

export function useDeleteAllocationsMutation() {
  return useMutation({
    mutationFn: async (params: DeleteAllocationParams) => {
      await apiDeleteAllocations(
        params.projectId,
        params.financialDocumentId,
        params.allocationIds
      );

      return params.allocationIds;
    },
  });
}
